
import { useState, useEffect, use } from 'react';
import { HideableView } from '../../Template';
import './editor_tabs.css'

export const EditorTabContent = ({tab_id, selected_id, children }) => {
    return <HideableView 
                className={""} 
                isVisible={tab_id === selected_id} >
            {children}
        </HideableView>
} 

export const EditorTabSelectBtn = ({ text, tab_id, selected_id, select }) => { 
    
    const [isSelected, setIsSelected] = useState(false)
 
    useEffect(()=>{
        setIsSelected(tab_id === selected_id)
    }, [tab_id, selected_id])
    
    const handle_click = () => {
        if (isSelected !== true) select(tab_id)
    }

    return  <input 
                className={`editor-tabs-navitem ${isSelected ? 'not-selected' : 'selected'}`} 
                type="button" 
                value={tab_id} 
                title={text} 
                disabled={isSelected}  
                onClick={handle_click} /> 

}

export const EditorTabContainer = ({children}) => <div className="editor_tab_container">{children}</div>
